import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainNotificationService {

  private mainNotificationHeight$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  public setMainNotificationHeight(height: number): void {
    this.mainNotificationHeight$.next(height);
  }

  public mainNotificationHeightAsObservable(): Observable<number> {
    return this.mainNotificationHeight$.asObservable();
  }
}
